import { Chip, ChipProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

export const ComingSoonChip: React.FC<ChipProps> = ({ sx = {}, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { root } = theme.components?.[`ComingSoonChip`]?.styleOverrides || {}
  return <Chip label={t("Coming soon")} sx={deepmerge(root, sx)} {...props} />
}
